












import { computed, defineComponent } from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';

import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import type { Area } from '@/useDeliveryAreaCode';

const { DEFAULT_AREA } = useDeliveryAreaCode();

const AreaCode = defineComponent({
  props: {
    area: {
      type: Object as PropType<Area>,
      default: () => ({ ...DEFAULT_AREA }),
    },
    displayCode: { type: Boolean, default: true },
    displayName: { type: Boolean, default: true },
  },
  setup(props) {
    const { distanceTypeToColor } = useDeliveryAreaCode();
    const computedColor = computed(() => distanceTypeToColor(props.area?.distanceType || ''));

    return {
      computedColor,
      distanceTypeToColor,
    };
  },
});

export default AreaCode;
